export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_R2.fd2640ab.png";